import type { VariablesOf } from "@graphql-typed-document-node/core";
import { safe } from "pb.safe";

import { $, query } from "../../../../../schema.dev-sdk-api-appsync.generated";
import type { ApiClient } from "../../shared/shared/api-client";

export async function getTerminals({
	apiClient,
	...variables
}: { apiClient: ApiClient } & VariablesOf<typeof getTerminals.gql.getSites>) {
	const sites = await safe(() =>
		apiClient.request(getTerminals.gql.getSites, variables),
	);

	if (sites instanceof Error) {
		return sites;
	}

	return {
		sites,
	};
}

getTerminals.gql = {
	getSites: query("getSites", (q) => [
		q.getSites(
			{ deviceUuid: $("deviceId"), limit: 100, nextToken: $("nextToken") },
			(c) => [
				c.nextToken((c) => [c.type, c.siteNameSortKey]),
				c.sites((c) => [
					c.id,
					c.name,
					c.devices(
						{ models: ["NEW9220", "NEW9830", "NEW9310Pro", "T2"] },
						(c) => [
							c.id,
							c.model,
							c.name,
							c.posSettings((c) => [c.active, c.posRegisterName]),
						],
					),
				]),
			],
		),
	]),
};
